import { AuthContext as e, AuthorizedApiBase as t } from "@urbanx/agx.auth.client";
import n from "axios";
import { c as r } from "react/compiler-runtime";
import { jsx as i } from "react/jsx-runtime";
import { createContext as a, useContext as o, useEffect as s, useState as c } from "react";
import { useMutation as l, useQuery as u, useQueryClient as d } from "@tanstack/react-query";
//#region src/Client.ts
function f(e) {
	return e instanceof Date ? e.toISOString() : String(e);
}
var p = class extends t {
	instance;
	baseUrl;
	jsonParseReviver;
	constructor(e, t) {
		super(), this.instance = t ?? n.create(), this.baseUrl = e ?? "http://127.0.0.1:7091/Crm";
	}
	connectCrmAgencyProvider(e, t) {
		let r = this.baseUrl + "/ConnectCrmAgencyProvider", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processConnectCrmAgencyProvider(e)));
	}
	processConnectCrmAgencyProvider(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? z("No description", e.status, e.data, t) : e.status === 409 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 429 || e.status === 503 ? z("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : z("An unexpected server error occurred.", e.status, e.data, t);
	}
	createCrmLead(e, t) {
		let r = this.baseUrl + "/CreateCrmLead", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processCreateCrmLead(e)));
	}
	processCreateCrmLead(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 501 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : z("An unexpected server error occurred.", e.status, e.data, t);
	}
	crmProviderWebhook(e, t, r) {
		let i = this.baseUrl + "/CrmProviderWebhook";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		i += "agencyId=" + encodeURIComponent(f(e)) + "&", i = i.replace(/[?&]$/, "");
		let a = JSON.stringify(t), o = {
			method: "POST",
			url: i,
			headers: { "Content-Type": "application/json" },
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processCrmProviderWebhook(e)));
	}
	processCrmProviderWebhook(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 || e.status === 501 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : z("An unexpected server error occurred.", e.status, e.data, t);
	}
	disconnectCrmAgencyProvider(e, t) {
		let r = this.baseUrl + "/DisconnectCrmAgencyProvider", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processDisconnectCrmAgencyProvider(e)));
	}
	processDisconnectCrmAgencyProvider(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? z("No description", e.status, e.data, t) : e.status === 409 || e.status === 501 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : z("An unexpected server error occurred.", e.status, e.data, t);
	}
	exportCrmNetworkItemizedTransactions(e, t) {
		let r = this.baseUrl + "/ExportCrmNetworkItemizedTransactions", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "text/csv"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processExportCrmNetworkItemizedTransactions(e)));
	}
	processExportCrmNetworkItemizedTransactions(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? z("No description", e.status, e.data, t) : e.status === 501 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : z("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmActiveListingsForAgency(e, t) {
		let r = this.baseUrl + "/GetCrmActiveListingsForAgency";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCrmActiveListingsForAgency(e)));
	}
	processGetCrmActiveListingsForAgency(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? z("No description", e.status, e.data, t) : e.status === 501 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : z("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmAgencyConnectionDetails(e, t) {
		let r = this.baseUrl + "/GetCrmAgencyConnectionDetails";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCrmAgencyConnectionDetails(e)));
	}
	processGetCrmAgencyConnectionDetails(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? z("No description", e.status, e.data, t) : e.status === 409 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : z("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmAgencyListingsPermanentLinkModel(e, t) {
		let r = this.baseUrl + "/GetCrmAgencyListingsPermanentLinkModel";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCrmAgencyListingsPermanentLinkModel(e)));
	}
	processGetCrmAgencyListingsPermanentLinkModel(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? z("No description", e.status, e.data, t) : e.status === 501 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : z("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmAgentDetails(e, t, r) {
		let i = this.baseUrl + "/GetCrmAgentDetails";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		if (i += "agencyId=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'agentId' must be defined and cannot be null.");
		i += "agentId=" + encodeURIComponent(f(t)) + "&", i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processGetCrmAgentDetails(e)));
	}
	processGetCrmAgentDetails(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? z("No description", e.status, e.data, t) : e.status === 501 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : z("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmContractCommissionDiscrepancies(e, t) {
		let r = this.baseUrl + "/GetCrmContractCommissionDiscrepancies";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCrmContractCommissionDiscrepancies(e)));
	}
	processGetCrmContractCommissionDiscrepancies(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? z("No description", e.status, e.data, t) : e.status === 501 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : z("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmCurrentPartnershipInformation(e, t) {
		let r = this.baseUrl + "/GetCrmCurrentPartnershipInformation";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCrmCurrentPartnershipInformation(e)));
	}
	processGetCrmCurrentPartnershipInformation(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? z("No description", e.status, e.data, t) : e.status === 501 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : z("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmEntityNumbers(e, t) {
		let r = this.baseUrl + "/GetCrmEntityNumbers", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCrmEntityNumbers(e)));
	}
	processGetCrmEntityNumbers(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? z("No description", e.status, e.data, t) : e.status === 501 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : z("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmExecutiveKeyMetrics(e, t) {
		let r = this.baseUrl + "/GetCrmExecutiveKeyMetrics";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCrmExecutiveKeyMetrics(e)));
	}
	processGetCrmExecutiveKeyMetrics(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? z("No description", e.status, e.data, t) : e.status === 501 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : z("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmExecutiveRunRateMetrics(e, t) {
		let r = this.baseUrl + "/GetCrmExecutiveRunRateMetrics";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCrmExecutiveRunRateMetrics(e)));
	}
	processGetCrmExecutiveRunRateMetrics(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? z("No description", e.status, e.data, t) : e.status === 501 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : z("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmLeaderboardStatisticsForEntity(e, t) {
		let r = this.baseUrl + "/GetCrmLeaderboardStatisticsForEntity", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCrmLeaderboardStatisticsForEntity(e)));
	}
	processGetCrmLeaderboardStatisticsForEntity(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? z("No description", e.status, e.data, t) : e.status === 501 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : z("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmListingByCampaignId(e, t, r) {
		let i = this.baseUrl + "/GetCrmListingByCampaignId";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		if (i += "agencyId=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		i += "campaignId=" + encodeURIComponent(f(t)) + "&", i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processGetCrmListingByCampaignId(e)));
	}
	processGetCrmListingByCampaignId(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? z("No description", e.status, e.data, t) : e.status === 501 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : z("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmListingDiscrepancies(e, t) {
		let r = this.baseUrl + "/GetCrmListingDiscrepancies";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCrmListingDiscrepancies(e)));
	}
	processGetCrmListingDiscrepancies(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? z("No description", e.status, e.data, t) : e.status === 501 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : z("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmNetworkPartnershipMetrics(e, t) {
		let r = this.baseUrl + "/GetCrmNetworkPartnershipMetrics", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCrmNetworkPartnershipMetrics(e)));
	}
	processGetCrmNetworkPartnershipMetrics(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? z("No description", e.status, e.data, t) : e.status === 501 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : z("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmNetworkStateMetrics(e, t) {
		let r = this.baseUrl + "/GetCrmNetworkStateMetrics", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCrmNetworkStateMetrics(e)));
	}
	processGetCrmNetworkStateMetrics(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? z("No description", e.status, e.data, t) : e.status === 501 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : z("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmPartnershipInformation(e, t) {
		let r = this.baseUrl + "/GetCrmPartnershipInformation", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCrmPartnershipInformation(e)));
	}
	processGetCrmPartnershipInformation(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? z("No description", e.status, e.data, t) : e.status === 501 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : z("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmPublishedListingDetail(e, t, r) {
		let i = this.baseUrl + "/GetCrmPublishedListingDetail";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		if (i += "agencyId=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'listingId' must be defined and cannot be null.");
		i += "listingId=" + encodeURIComponent(f(t)) + "&", i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processGetCrmPublishedListingDetail(e)));
	}
	processGetCrmPublishedListingDetail(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 501 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : z("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmPublishedListingDetails(e, t) {
		let r = this.baseUrl + "/GetCrmPublishedListingDetails", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCrmPublishedListingDetails(e)));
	}
	processGetCrmPublishedListingDetails(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 501 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : z("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmPublishedListingsAgentsAndSuburbs(e, t) {
		let r = this.baseUrl + "/GetCrmPublishedListingsAgentsAndSuburbs";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCrmPublishedListingsAgentsAndSuburbs(e)));
	}
	processGetCrmPublishedListingsAgentsAndSuburbs(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 501 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : z("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmStaffLeaderboardStatistics(e, t) {
		let r = this.baseUrl + "/GetCrmStaffLeaderboardStatistics";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCrmStaffLeaderboardStatistics(e)));
	}
	processGetCrmStaffLeaderboardStatistics(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? z("No description", e.status, e.data, t) : e.status === 501 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : z("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmStatisticsForEntity(e, t) {
		let r = this.baseUrl + "/GetCrmStatisticsForEntity", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCrmStatisticsForEntity(e)));
	}
	processGetCrmStatisticsForEntity(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? z("No description", e.status, e.data, t) : e.status === 501 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : z("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmSuburbs(e, t) {
		let r = this.baseUrl + "/GetCrmSuburbs", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCrmSuburbs(e)));
	}
	processGetCrmSuburbs(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? z("No description", e.status, e.data, t) : e.status === 501 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : z("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmTopPerformers(e, t) {
		let r = this.baseUrl + "/GetCrmTopPerformers";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCrmTopPerformers(e)));
	}
	processGetCrmTopPerformers(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? z("No description", e.status, e.data, t) : e.status === 501 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : z("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmUpcomingSettlementsForAgency(e, t) {
		let r = this.baseUrl + "/GetCrmUpcomingSettlementsForAgency";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCrmUpcomingSettlementsForAgency(e)));
	}
	processGetCrmUpcomingSettlementsForAgency(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? z("No description", e.status, e.data, t) : e.status === 501 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : z("An unexpected server error occurred.", e.status, e.data, t);
	}
	setCrmListingPublishedToPortal(e, t) {
		let r = this.baseUrl + "/SetCrmListingPublishedToPortal", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processSetCrmListingPublishedToPortal(e)));
	}
	processSetCrmListingPublishedToPortal(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? z("No description", e.status, e.data, t) : e.status === 501 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : z("An unexpected server error occurred.", e.status, e.data, t);
	}
	updateCrmAgentDetails(e, t) {
		let r = this.baseUrl + "/UpdateCrmAgentDetails", i = {
			method: "PUT",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processUpdateCrmAgentDetails(e)));
	}
	processUpdateCrmAgentDetails(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? z("No description", e.status, e.data, t) : e.status === 501 ? z("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : z("An unexpected server error occurred.", e.status, e.data, t);
	}
}, m = /* @__PURE__ */ function(e) {
	return e.Rex = "Rex", e.Agentbox = "Agentbox", e.BoxAndDice = "BoxAndDice", e.Vault = "Vault", e;
}({}), h = /* @__PURE__ */ function(e) {
	return e.Supported = "Supported", e.Unsupported = "Unsupported", e.PendingValidation = "PendingValidation", e;
}({}), g = /* @__PURE__ */ function(e) {
	return e.Supported = "Supported", e.Unsupported = "Unsupported", e.PendingValidation = "PendingValidation", e;
}({}), _ = /* @__PURE__ */ function(e) {
	return e.Supported = "Supported", e.Unsupported = "Unsupported", e.PendingValidation = "PendingValidation", e;
}({}), v = /* @__PURE__ */ function(e) {
	return e.Supported = "Supported", e.Unsupported = "Unsupported", e.PendingValidation = "PendingValidation", e;
}({}), y = /* @__PURE__ */ function(e) {
	return e.Supported = "Supported", e.Unsupported = "Unsupported", e.PendingValidation = "PendingValidation", e;
}({}), b = /* @__PURE__ */ function(e) {
	return e.Supported = "Supported", e.Unsupported = "Unsupported", e.PendingValidation = "PendingValidation", e;
}({}), x = /* @__PURE__ */ function(e) {
	return e.Supported = "Supported", e.Unsupported = "Unsupported", e.PendingValidation = "PendingValidation", e;
}({}), S = /* @__PURE__ */ function(e) {
	return e.Rex = "Rex", e.Agentbox = "Agentbox", e.BoxAndDice = "BoxAndDice", e.Vault = "Vault", e;
}({}), ee = /* @__PURE__ */ function(e) {
	return e.Rex = "Rex", e.Agentbox = "Agentbox", e.BoxAndDice = "BoxAndDice", e.Vault = "Vault", e;
}({}), te = /* @__PURE__ */ function(e) {
	return e.NotConnected = "NotConnected", e.Connected = "Connected", e;
}({}), C = /* @__PURE__ */ function(e) {
	return e.Rex = "Rex", e.Agentbox = "Agentbox", e.BoxAndDice = "BoxAndDice", e.Vault = "Vault", e;
}({}), w = /* @__PURE__ */ function(e) {
	return e.NotConnected = "NotConnected", e.Connected = "Connected", e;
}({}), T = /* @__PURE__ */ function(e) {
	return e.Silver = "Silver", e.Gold = "Gold", e.Platinum = "Platinum", e.XPartner = "XPartner", e.Bronze = "Bronze", e;
}({}), E = /* @__PURE__ */ function(e) {
	return e.Written = "Written", e.Unconditional = "Unconditional", e.Settled = "Settled", e.ExpectedSettlement = "ExpectedSettlement", e;
}({}), D = /* @__PURE__ */ function(e) {
	return e.WholeNumber = "WholeNumber", e.Currency = "Currency", e.Percentage = "Percentage", e;
}({}), O = /* @__PURE__ */ function(e) {
	return e.VirtualTour = "VirtualTour", e.VideoLink = "VideoLink", e.InteractiveFloorPlan = "InteractiveFloorPlan", e.MiniWeb = "MiniWeb", e.ExternalLink = "ExternalLink", e.Unknown = "Unknown", e;
}({}), k = /* @__PURE__ */ function(e) {
	return e.Silver = "Silver", e.Gold = "Gold", e.Platinum = "Platinum", e.XPartner = "XPartner", e.Bronze = "Bronze", e;
}({}), A = /* @__PURE__ */ function(e) {
	return e.Warning = "Warning", e.Error = "Error", e;
}({}), j = /* @__PURE__ */ function(e) {
	return e.Current = "Current", e.Sold = "Sold", e.Withdrawn = "Withdrawn", e.Leased = "Leased", e;
}({}), M = /* @__PURE__ */ function(e) {
	return e.Available = "Available", e.UnderOffer = "UnderOffer", e.Sold = "Sold", e;
}({}), N = /* @__PURE__ */ function(e) {
	return e.Rex = "Rex", e.Agentbox = "Agentbox", e.BoxAndDice = "BoxAndDice", e.Vault = "Vault", e;
}({}), P = /* @__PURE__ */ function(e) {
	return e[e._0 = 0] = "_0", e[e._1 = 1] = "_1", e[e._2 = 2] = "_2", e[e._3 = 3] = "_3", e;
}({}), F = /* @__PURE__ */ function(e) {
	return e.WholeNumber = "WholeNumber", e.Currency = "Currency", e.Percentage = "Percentage", e;
}({}), I = /* @__PURE__ */ function(e) {
	return e.Rex = "Rex", e.Agentbox = "Agentbox", e.BoxAndDice = "BoxAndDice", e.Vault = "Vault", e;
}({}), L = /* @__PURE__ */ function(e) {
	return e[e._0 = 0] = "_0", e[e._1 = 1] = "_1", e[e._2 = 2] = "_2", e[e._3 = 3] = "_3", e[e._4 = 4] = "_4", e[e._5 = 5] = "_5", e[e._6 = 6] = "_6", e[e._7 = 7] = "_7", e;
}({}), R = class extends Error {
	message;
	status;
	response;
	headers;
	result;
	constructor(e, t, n, r, i) {
		super(), this.message = e, this.status = t, this.response = n, this.headers = r, this.result = i;
	}
	isCrmApiException = !0;
	static isCrmApiException(e) {
		return e.isCrmApiException === !0;
	}
};
function z(e, t, n, r, i) {
	throw i ?? new R(e, t, n, r, null);
}
//#endregion
//#region src/useClientContext.tsx
var B = "crm";
function V(e) {
	let t = Object.getPrototypeOf(e);
	for (let n of Object.getOwnPropertyNames(t)) {
		let r = t[n];
		typeof r == "function" && n !== "constructor" && (e[n] = r.bind(e));
	}
	return e;
}
var H = (e, t, n) => {
	let r = new p(e);
	return r.setAuthConfig(t, n), V(r);
}, U = ({ baseApiUri: e, localUris: t }) => {
	if (!e) throw console.error("Base API URI is undefined"), Error("Base API URI is undefined");
	return t?.crm || `${e}/crm`;
}, W = (t) => {
	let n = r(10), { agxConfig: i } = t, { getAuthToken: a } = o(e), l, u, d;
	n[0] !== i || n[1] !== a ? (l = U(i), u = c, d = H(l, a, i), n[0] = i, n[1] = a, n[2] = l, n[3] = u, n[4] = d) : (l = n[2], u = n[3], d = n[4]);
	let [f, p] = u(d), m, h;
	return n[5] !== i || n[6] !== l || n[7] !== a ? (m = () => {
		let e = H(l, a, i);
		p(e);
	}, h = [
		a,
		i,
		l
	], n[5] = i, n[6] = l, n[7] = a, n[8] = m, n[9] = h) : (m = n[8], h = n[9]), s(m, h), f;
}, G = a({}), K = (e) => {
	let t = r(5), { appConfig: n, children: a } = e, o;
	t[0] === n ? o = t[1] : (o = { agxConfig: n }, t[0] = n, t[1] = o);
	let s = W(o);
	if (!s) return null;
	let c;
	return t[2] !== s || t[3] !== a ? (c = /* @__PURE__ */ i(G.Provider, {
		value: s,
		children: a
	}), t[2] = s, t[3] = a, t[4] = c) : c = t[4], c;
}, q = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(G), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.connectCrmAgencyProvider(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		connectCrmAgencyProvider: d,
		connectCrmAgencyProviderPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, J = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(G), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.createCrmLead(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		createCrmLead: d,
		createCrmLeadPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Y = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(G), c;
	t[2] === s ? c = t[3] : (c = async (e) => {
		let { agencyId: t, body: n } = e;
		return s.crmProviderWebhook(t, n);
	}, t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		crmProviderWebhook: d,
		crmProviderWebhookPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, X = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(G), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.disconnectCrmAgencyProvider(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		disconnectCrmAgencyProvider: d,
		disconnectCrmAgencyProviderPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Z = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(G), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.exportCrmNetworkItemizedTransactions(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		exportCrmNetworkItemizedTransactions: d,
		exportCrmNetworkItemizedTransactionsPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Q = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(G), s;
	n[0] === e ? s = n[1] : (s = ["getCrmActiveListingsForAgency", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getCrmActiveListingsForAgency(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, ne = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getCrmActiveListingsForAgency", e] });
	}, e[0] = t, e[1] = n), n;
}, re = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(G), s;
	n[0] === e ? s = n[1] : (s = ["getCrmAgencyConnectionDetails", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getCrmAgencyConnectionDetails(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, ie = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getCrmAgencyConnectionDetails", e] });
	}, e[0] = t, e[1] = n), n;
}, ae = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(G), s;
	n[0] === e ? s = n[1] : (s = ["getCrmAgencyListingsPermanentLinkModel", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getCrmAgencyListingsPermanentLinkModel(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, oe = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getCrmAgencyListingsPermanentLinkModel", e] });
	}, e[0] = t, e[1] = n), n;
}, se = (e, t, n) => {
	let i = r(15), a = n === void 0 || n, s = o(G), c;
	i[0] !== e || i[1] !== t ? (c = [
		"getCrmAgentDetails",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== e || i[4] !== t || i[5] !== s ? (d = (n) => {
		let { signal: r } = n;
		return s.getCrmAgentDetails(e, t, r);
	}, i[3] = e, i[4] = t, i[5] = s, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, ce = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"getCrmAgentDetails",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, le = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(G), s;
	n[0] === e ? s = n[1] : (s = ["getCrmContractCommissionDiscrepancies", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getCrmContractCommissionDiscrepancies(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, ue = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getCrmContractCommissionDiscrepancies", e] });
	}, e[0] = t, e[1] = n), n;
}, de = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(G), s;
	n[0] === e ? s = n[1] : (s = ["getCrmCurrentPartnershipInformation", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getCrmCurrentPartnershipInformation(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, fe = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getCrmCurrentPartnershipInformation", e] });
	}, e[0] = t, e[1] = n), n;
}, pe = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(G), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.getCrmEntityNumbers(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		getCrmEntityNumbers: d,
		getCrmEntityNumbersPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, me = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(G), s;
	n[0] === e ? s = n[1] : (s = ["getCrmExecutiveKeyMetrics", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getCrmExecutiveKeyMetrics(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, he = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getCrmExecutiveKeyMetrics", e] });
	}, e[0] = t, e[1] = n), n;
}, ge = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(G), s;
	n[0] === e ? s = n[1] : (s = ["getCrmExecutiveRunRateMetrics", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getCrmExecutiveRunRateMetrics(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, _e = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getCrmExecutiveRunRateMetrics", e] });
	}, e[0] = t, e[1] = n), n;
}, ve = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(G), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.getCrmLeaderboardStatisticsForEntity(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		getCrmLeaderboardStatisticsForEntity: d,
		getCrmLeaderboardStatisticsForEntityPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, ye = (e, t, n) => {
	let i = r(15), a = n === void 0 || n, s = o(G), c;
	i[0] !== e || i[1] !== t ? (c = [
		"getCrmListingByCampaignId",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== e || i[4] !== s || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.getCrmListingByCampaignId(e, t, r);
	}, i[3] = e, i[4] = s, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, be = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"getCrmListingByCampaignId",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, xe = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(G), s;
	n[0] === e ? s = n[1] : (s = ["getCrmListingDiscrepancies", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getCrmListingDiscrepancies(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Se = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getCrmListingDiscrepancies", e] });
	}, e[0] = t, e[1] = n), n;
}, Ce = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(G), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.getCrmNetworkPartnershipMetrics(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		getCrmNetworkPartnershipMetrics: d,
		getCrmNetworkPartnershipMetricsPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, we = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(G), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.getCrmNetworkStateMetrics(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		getCrmNetworkStateMetrics: d,
		getCrmNetworkStateMetricsPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Te = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(G), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.getCrmPartnershipInformation(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		getCrmPartnershipInformation: d,
		getCrmPartnershipInformationPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Ee = (e, t, n) => {
	let i = r(15), a = n === void 0 || n, s = o(G), c;
	i[0] !== e || i[1] !== t ? (c = [
		"getCrmPublishedListingDetail",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== e || i[4] !== s || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.getCrmPublishedListingDetail(e, t, r);
	}, i[3] = e, i[4] = s, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, De = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"getCrmPublishedListingDetail",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, $ = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(G), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.getCrmPublishedListingDetails(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		getCrmPublishedListingDetails: d,
		getCrmPublishedListingDetailsPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Oe = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(G), s;
	n[0] === e ? s = n[1] : (s = ["getCrmPublishedListingsAgentsAndSuburbs", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getCrmPublishedListingsAgentsAndSuburbs(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, ke = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getCrmPublishedListingsAgentsAndSuburbs", e] });
	}, e[0] = t, e[1] = n), n;
}, Ae = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(G), s;
	n[0] === e ? s = n[1] : (s = ["getCrmStaffLeaderboardStatistics", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getCrmStaffLeaderboardStatistics(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, je = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getCrmStaffLeaderboardStatistics", e] });
	}, e[0] = t, e[1] = n), n;
}, Me = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(G), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.getCrmStatisticsForEntity(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		getCrmStatisticsForEntity: d,
		getCrmStatisticsForEntityPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Ne = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(G), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.getCrmSuburbs(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		getCrmSuburbs: d,
		getCrmSuburbsPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Pe = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(G), s;
	n[0] === e ? s = n[1] : (s = ["getCrmTopPerformers", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getCrmTopPerformers(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Fe = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getCrmTopPerformers", e] });
	}, e[0] = t, e[1] = n), n;
}, Ie = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(G), s;
	n[0] === e ? s = n[1] : (s = ["getCrmUpcomingSettlementsForAgency", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getCrmUpcomingSettlementsForAgency(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Le = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getCrmUpcomingSettlementsForAgency", e] });
	}, e[0] = t, e[1] = n), n;
}, Re = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(G), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.setCrmListingPublishedToPortal(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		setCrmListingPublishedToPortal: d,
		setCrmListingPublishedToPortalPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, ze = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(G), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.updateCrmAgentDetails(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		updateCrmAgentDetails: d,
		updateCrmAgentDetailsPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
};
//#endregion
export { m as ConnectCrmAgencyProviderRequestProvider, h as CrmAgencyConnectionCapabilityResponseConnectionManagement, g as CrmAgencyConnectionCapabilityResponseInvoices, _ as CrmAgencyConnectionCapabilityResponseListingRead, v as CrmAgencyConnectionCapabilityResponseListingWrite, y as CrmAgencyConnectionCapabilityResponseReporting, b as CrmAgencyConnectionCapabilityResponseTrustAccounting, x as CrmAgencyConnectionCapabilityResponseWebhooks, S as CrmAgencyConnectionDetailsResponseActiveProvider, ee as CrmAgencyConnectionProviderResponseProvider, te as CrmAgencyConnectionProviderResponseStatus, C as CrmAgencyProviderConnectionResponseProvider, w as CrmAgencyProviderConnectionResponseStatus, G as CrmApiContext, R as CrmApiException, K as CrmApiProvider, p as CrmClient, T as CrmCurrentReviewPeriodPartnershipInformationPartnershipLevel, E as CrmExecutiveMetricsResponseContractType, D as CrmKeyMetricMetricType, O as CrmListingLinkLinkType, k as CrmPartnershipInformationPartnershipLevel, A as CrmProviderDiagnosticResponseSeverity, j as CrmPublishedListingModelListingState, M as CrmPublishedListingModelOverridenListingStatus, N as CrmResultMetadataProviderKind, P as CrmResultMetadataStatus, B as CrmRoute, F as CrmRunRateMetricMetricType, I as DisconnectCrmAgencyProviderRequestProvider, L as JsonElementValueKind, q as useConnectCrmAgencyProvider, J as useCreateCrmLead, W as useCrmClientContext, Y as useCrmProviderWebhook, X as useDisconnectCrmAgencyProvider, Z as useExportCrmNetworkItemizedTransactions, Q as useGetCrmActiveListingsForAgency, re as useGetCrmAgencyConnectionDetails, ae as useGetCrmAgencyListingsPermanentLinkModel, se as useGetCrmAgentDetails, le as useGetCrmContractCommissionDiscrepancies, de as useGetCrmCurrentPartnershipInformation, pe as useGetCrmEntityNumbers, me as useGetCrmExecutiveKeyMetrics, ge as useGetCrmExecutiveRunRateMetrics, ve as useGetCrmLeaderboardStatisticsForEntity, ye as useGetCrmListingByCampaignId, xe as useGetCrmListingDiscrepancies, Ce as useGetCrmNetworkPartnershipMetrics, we as useGetCrmNetworkStateMetrics, Te as useGetCrmPartnershipInformation, Ee as useGetCrmPublishedListingDetail, $ as useGetCrmPublishedListingDetails, Oe as useGetCrmPublishedListingsAgentsAndSuburbs, Ae as useGetCrmStaffLeaderboardStatistics, Me as useGetCrmStatisticsForEntity, Ne as useGetCrmSuburbs, Pe as useGetCrmTopPerformers, Ie as useGetCrmUpcomingSettlementsForAgency, ne as useInvalidateUseGetCrmActiveListingsForAgency, ie as useInvalidateUseGetCrmAgencyConnectionDetails, oe as useInvalidateUseGetCrmAgencyListingsPermanentLinkModel, ce as useInvalidateUseGetCrmAgentDetails, ue as useInvalidateUseGetCrmContractCommissionDiscrepancies, fe as useInvalidateUseGetCrmCurrentPartnershipInformation, he as useInvalidateUseGetCrmExecutiveKeyMetrics, _e as useInvalidateUseGetCrmExecutiveRunRateMetrics, be as useInvalidateUseGetCrmListingByCampaignId, Se as useInvalidateUseGetCrmListingDiscrepancies, De as useInvalidateUseGetCrmPublishedListingDetail, ke as useInvalidateUseGetCrmPublishedListingsAgentsAndSuburbs, je as useInvalidateUseGetCrmStaffLeaderboardStatistics, Fe as useInvalidateUseGetCrmTopPerformers, Le as useInvalidateUseGetCrmUpcomingSettlementsForAgency, Re as useSetCrmListingPublishedToPortal, ze as useUpdateCrmAgentDetails };
